import type { ActiveAttributeId } from 'cadenza/workbook/api/active-attribute-id';
import type { WorkbookAttributeDto } from 'cadenza/workbook/api/workbook-attribute-dto';
import type { ChartAttributeBundle } from 'cadenza/workbook/model/chart-attribute-bundle.gen';
import type { MapAttributeBundle } from 'cadenza/workbook/model/map-attribute-bundle.gen';
import type { TableAttributeBundle } from 'cadenza/workbook/model/table-attribute-bundle.gen';

/** @see net/disy/cadenza/workbook/model/AttributeBundleName.java */
export type AttributeBundleName =
  | ChartAttributeBundle
  | TableAttributeBundle
  | MapAttributeBundle
  | typeof INDICATOR_BUNDLE_NAME
  | typeof UNUSED_BUNDLE_NAME
  | typeof SPATIAL_FILTER_BUNDLE_NAME
  | typeof REPORT_BUNDLE_NAME
  | typeof TEXT_WITH_DATA_BUNDLE_NAME
  | typeof CONTROLLER_BUNDLE_NAME
  | typeof WEBPAGE_BUNDLE_NAME
  | typeof PRECONDITION_BUNDLE_NAME;

export const INDICATOR_BUNDLE_NAME = 'MEASURE';
export const CONTROLLER_BUNDLE_NAME = 'CONTROLLER';
export const WEBPAGE_BUNDLE_NAME = 'WEBPAGE';
export const UNUSED_BUNDLE_NAME = 'UNUSED';
export const SPATIAL_FILTER_BUNDLE_NAME = 'SPATIAL_FILTER';
export const REPORT_BUNDLE_NAME = 'REFERENCE_ATTRIBUTE';
export const TEXT_WITH_DATA_BUNDLE_NAME = 'ATTRIBUTES';
export const PRECONDITION_BUNDLE_NAME = 'PRECONDITION';

export type ByBundle<T> = Partial<Record<AttributeBundleName, T>>;
export type AttributeIdsByBundle = ByBundle<ActiveAttributeId[]>;
export type AttributesByBundle = ByBundle<WorkbookAttributeDto[]>;
